import React, { Component } from "react";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { withNavigationContext } from "../util/withNavigationContext";
import CenteredPaper from "../layouts/CenteredPaper";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import Titles from "../molecules/Titles";
import UswfList from "../molecules/UswfList";
import { BiggerButton } from "../atoms/buttons/BiggerButton";
import ILearn from "../molecules/ILearn";

class BuyDoYouWantToFastTrackPage extends Component {
  render() {
    const content = contentMap.BuyDoYouWantToFastTrackPage;
    const navigationsAway = customNavigationMap.BuyDoYouWantToFastTrackPage;

    return (
      <div className="page-wrapper">
        <ILearn content={content}>
          <CenteredPaper>
            <Titles content={content} />
            <UswfList content={content} />
            <div className="bigger-buttons-wrapper">
              <div className="percent-icon-wrapper">
                <BiggerButton
                  icon="/img/svg_icons/fast_track.svg"
                  title="Fast Track"
                  subtitle={content.firstChoice}
                  onClick={() =>
                    this.props.navigationContext.goNext(
                      navigationsAway.Primary,
                      true
                    )
                  }
                />
              </div>
              <BiggerButton
                icon="/img/svg_icons/Insight_Path.svg"
                title="Insight Path"
                subtitle={content.secondChoice}
                onClick={() =>
                  this.props.navigationContext.goNext(
                    navigationsAway.Secondary,
                    true
                  )
                }
              />
            </div>
          </CenteredPaper>
        </ILearn>
      </div>
    );
  }
}

export default withRouterUtilities(
  withNavigationContext(BuyDoYouWantToFastTrackPage)
);
